module.exports = __webpack_public_path__ + "img/UTQUIA.c7fe785c.png";